import Main from "./Main";

const UploadPicturePage = () => {
  return (
    <section className="h-full space-y-3 lg:space-y-5">
      <Main />
    </section>
  );
};

export default UploadPicturePage;
